/**
 * Component Registry for Repli Sandbox Avenew Theme
 * 
 * Extends the base avenue theme registry with Repli Sandbox Avenew specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-avenue/registry';
import { Hero } from './components/Hero';

/**
 * Repli Sandbox Avenew specific component overrides.
 * These components have been customized for the Repli Sandbox Avenew brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const replisandboxavenewOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const replisandboxavenewOverrides: Partial<ComponentRegistry> = {
  Hero,
};

/**
 * Final merged registry for Repli Sandbox Avenew properties.
 * Inherits all components from the avenue theme, with Repli Sandbox Avenew overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...replisandboxavenewOverrides,
};

export default registry;
